import './_empty-cart.scss';

export default () => {};
